import { Box, Stack, Typography } from "@mui/material";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";

export default function CompanyInfo() {
  return (
    <Box sx={{ pt: 0 }}>
      <Stack spacing={3}>
         {/* Legal Name */}
         <Stack direction="row" spacing={.5} alignItems="center" sx={{marginTop: "20px!important"}}>
          {/* <BusinessCenterOutlinedIcon sx={{ color: "white", fontSize: 26 }} /> */}
          <Typography
            variant="body2"
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              color: "#a1a09f",
              fontSize: "15px",
              letterSpacing: "0.3px",
              lineHeight: "18px",
            }}
          >
            Consulting 2020 s.r.o.
          </Typography>
        </Stack>
        {/* Address */}
        <Stack direction="row" spacing={.5} alignItems="flex-start" sx={{marginTop: "10px!important"}}>
          {/* <RoomOutlinedIcon sx={{ color: "white", fontSize: 26 }} /> */}
          <Typography
            variant="body2"
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              color: "#a1a09f",
              fontSize: "15px",
              letterSpacing: "0.3px",
              lineHeight: "22px",
            }}
          >
            Kostolný rad 318/15 <br/>
            Kráľovský Chlmec 077 01
          </Typography>
        </Stack>
        
        {/* Phone Number */}
        <Stack direction="row" spacing={.5} alignItems="center" sx={{marginTop: "10px!important"}}>
          {/* <CallOutlinedIcon sx={{ color: "white", fontSize: 26 }} /> */}
          <Typography
            variant="body2"
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              color: "#a1a09f",
              fontSize: "15px",
              letterSpacing: "0.3px",
              lineHeight: "18px",
            }}
          >
            +421 952307969
          </Typography>
        </Stack>
        
        <Stack direction="row" spacing={.5} alignItems="center" sx={{marginTop: "10px!important"}}>
          {/* <CallOutlinedIcon sx={{ color: "white", fontSize: 26 }} /> */}
          <Typography
            variant="body2"
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              color: "#a1a09f",
              fontSize: "15px",
              letterSpacing: "0.3px",
              lineHeight: "18px",
            }}
          >
            info@arkyn-tech.com
          </Typography>
        </Stack>
        
      </Stack>
    </Box>
  );
}